/**
 * WalletConnect V2 connector
 *
 * This file now imports from the centralized chain config.
 * Chain selection is based on REACT_APP_CHAIN_ID.
 */
import { initializeConnector } from "@web3-react/core";
import { WalletConnect as WalletConnectV2 } from "@web3-react/walletconnect-v2";

import { ChainIdEnum } from "../../../enums/chain";
import {
  getChainIdFromEnv,
  isMainnet,
} from "../../../config/chains";

/**
 * Get WalletConnect supported chains based on current environment
 * Uses centralized config to determine mainnet vs testnet
 */
const getWalletConnectChains = (): ChainIdEnum[] => {
  const currentChainId = getChainIdFromEnv();

  if (isMainnet()) {
    return [ChainIdEnum.ETH_MAINNET, ChainIdEnum.ARBITRUM, ChainIdEnum.OPTIMISM];
  }

  // For testnets, include current chain and common testnet chains
  const chains = new Set<ChainIdEnum>([
    currentChainId,
    ChainIdEnum.SEPOLIA_TESTNET,
    ChainIdEnum.MEGAETH_TESTNET,
    ChainIdEnum.BASECAMP_TESTNET,
    ChainIdEnum.DOGEOS_TESTNET,
    ChainIdEnum.ARBITRUM_TESTNET,
    ChainIdEnum.OPTIMISM_TESTNET,
  ]);

  return Array.from(chains);
};

const chains = getWalletConnectChains();

export const [walletConnectV2, hooks] = initializeConnector<WalletConnectV2>(
  (actions: any) =>
    new WalletConnectV2({
      actions,
      defaultChainId: chains[0],
      options: {
        projectId: process.env.REACT_APP_WALLET_CONNECT_PROJECT_ID!,
        chains: [chains[0]],
        optionalChains: chains,
        showQrModal: true,
        optionalMethods: ["eth_signTypedData_v4"],
      },
    })
);
